import { render, staticRenderFns } from "./CategoryCardWeb.vue?vue&type=template&id=a5595e10&scoped=true"
import script from "./CategoryCardWeb.vue?vue&type=script&lang=js"
export * from "./CategoryCardWeb.vue?vue&type=script&lang=js"
import style0 from "./CategoryCardWeb.vue?vue&type=style&index=0&id=a5595e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5595e10",
  null
  
)

export default component.exports